import store from '@/store';

/** 判斷來源別 */
export function isMobileLogin() {
    // authenticationType : 判斷來源別隱藏天地板
    // 手機e方便登入：authenticationType = 'MOBILE_LOGIN'
    // 保戶會員專區登入：authenticationType = 'SCV_LOGIN' 'TEST_LOGIN'
    return store.state.permissions?.userInfo?.authenticationType === 'MOBILE_LOGIN';
}

export function isNullOrUndefined(value) {
    return value === null || value === undefined;
}

export function isProdMode() {
    return process.env.VUE_APP_MODE === 'prod';
}
export function isDevMode() {
    return process.env.VUE_APP_MODE === 'dev';
}
